<template>
  <v-container class="elevation-2">
    <v-row
      v-for="line in logLines"
      :key="`logLine-${line.id}`"
      dense
    >
      <v-col cols="12">
        <v-chip
          :color="line.chipColor"
          outlined
          x-small
          class="mr-2"
        >
          {{ line.chipText }}
        </v-chip>
        <span class="rs-line-text">{{ line.text }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: [
    'logLines',
  ],

  data: () => ({

  }),
};
</script>

<style>

</style>
